import { Outlet } from 'react-router';
import { Footer } from './Footer';
import { Header } from './Header';
import { ScrollToTop } from './ScrollToTop';
import { Seo } from './Seo';
import styles from './Layout.module.css';

/**
 * Page shell: skip link, header, main landmark, footer.
 *
 * `tabIndex={-1}` on main is what makes the skip link actually move focus in
 * every browser - without it Safari and Firefox scroll but leave focus behind.
 */
export function Layout() {
  return (
    <div className={styles.shell}>
      <Seo />
      <ScrollToTop />
      <a href="#main" className={styles.skipLink}>
        Skip to main content
      </a>
      <Header />
      <main id="main" className={styles.main} tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
